module.exports = __webpack_public_path__ + "img/Zubrene.bc69a6a0.png";